import moment from "moment";
import { memo, useState } from "react";
import { createPortal } from "react-dom";
import { Card, Row, Col, Form, Button, Dropdown, Collapse } from "react-bootstrap";

import {
  FaSearch,
  FaSyncAlt,
  FaChevronUp,
  FaChevronDown,
  FaEye,
  FaTrash,
  FaCheck,
  FaFlag
} from "react-icons/fa";
import { NotificationAction } from "../../constants/NotificationAction ";
import {
  getAllNotificationTypeWise,
  updateNotificationAction
} from "../../redux/services/notification.service";
import { Each } from "../../components/common/Each";
import { useNavigate } from "react-router-dom";
import { confirmAction } from "../../components/common/commonAlert";
import useRoles from "../../constants/useRoles";

const NotificationPanel = ({
  notificationType,
  notificationData,
  setNotificationData,
  unRead,
  setUnRead,
  totalCount,
  filterList,
  onViewMore,
  onRefresh,
  onDelete,
  onSearch,
  onFilter
}) => {
  const [search, setSearch] = useState("");
  const [action, setAction] = useState("All");
  const [showNotifications, setShowNotifications] = useState(true);
  const visibleCount = notificationData.length ?? 0;
  const navigate = useNavigate();
  const { readOnly } = useRoles();
  const [show, setShow] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notifiationTypeReqModel, setNotificationTypeReqModel] = useState({
    WebuserId: 0,
    SearchText: "",
    NotificationTypeId: null,
    FilterBy: 1,
    SortCol: "NotificationId",
    SortDir: "desc",
    PageNo: 1,
    PageSize: 10
  });

  const showConfirmation = (notificationId, action, notificationTypeId) => {
    confirmAction(
      `Are you sure you want to ${action == NotificationAction.Delete ? "delete" : "undelete"} this notification?`,
      () => handleNotificationAction(notificationId, action, null, notificationType),
      "Yes",
      "question"
    );
  };
  const filterConfirmation = (
    notificationType,
    notificationFilterId,
    isActionFilter,
    filterName
  ) => {
    confirmAction(
      `Are you sure you want to ${filterName.toLowerCase()}?`,
      () => onFilter(notificationType, notificationFilterId, isActionFilter),
      "Yes",
      "question"
    );
  };

  const handleNotificationAction = async (notificationId, action, groupId, notificationType) => {
    const payload = {
      notificationId,
      action,
      groupId
    };
    const response = await updateNotificationAction(payload);
    if (response.statusCode === 200) {
      if (NotificationAction.Read == action) {
        setUnRead((prev) => prev - 1);
      } else if (action === NotificationAction.Unread) {
        setUnRead((prev) => prev + 1);
      }
      setNotificationData((prev) =>
        prev.map((item) => {
          if (item.notificationId !== notificationId) {
            return item;
          }

          if (action === NotificationAction.Complete || action === NotificationAction.Incomplete) {
            return {
              ...item,
              isComplete: !item.isComplete
            };
          }

          if (action === NotificationAction.Flag || action === NotificationAction.Unflag) {
            return {
              ...item,
              isNotificationFlag: !item.isNotificationFlag
            };
          }

          if (action === NotificationAction.Read || action === NotificationAction.Unread) {
            return {
              ...item,
              isRead: !item.isRead
            };
          }
          if (action === NotificationAction.Delete || action === NotificationAction.Undelete) {
            onDelete(notificationType);
          }
          return item;
        })
      );
    }
  };
  const handelViewAll = async () => {
    setShow(true);
    const qry = `?searchText=${encodeURIComponent(notifiationTypeReqModel?.SearchText || "")}&notificationTypeId=${notifiationTypeReqModel?.NotificationTypeId ?? ""}&filterBy=${notifiationTypeReqModel?.FilterBy}&sortCol=${notifiationTypeReqModel?.SortCol || ""}&sortDir=${notifiationTypeReqModel?.SortDir || ""}&startRow=${notifiationTypeReqModel?.StartRow}&pageSize=${notifiationTypeReqModel?.PageSize}`;
    // const response = await getAllNotificationTypeWise(qry);
    // if (response.statusCode === 200) {
    //   setNotifications(response?.data?.data);
    // }
  };
  const AllNotificationModel = memo(() => {
    if (!show) return null;
    return (
      <div className="container py-4">
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-xl modal-dialog-centered p-5">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">
                  {notificationType === "1" ? "Action Required" : "General"}
                </h5>

                <button type="button" className="btn-close" onClick={() => setShow(false)}></button>
              </div>

              <div className="modal-body">
                <div className="container p-0 m-0 row mw-100"></div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShow(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  });

  return (
    <>
      <AllNotificationModel />
      <Card className="notification-card shadow">
        <Card.Header className="notification-header py-8">
          <Row className="align-items-center">
            <Col lg={3} md={12}>
              <div className="notification-title">
                {notificationType === "1" ? "Action Required" : "General"}
                <span className="notification-count">{unRead}</span>
              </div>
            </Col>

            <Col lg={3} md={6}>
              <div className="search-box">
                <Form.Control
                  className="search-input"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    onSearch(notificationType, e.target.value);
                  }}
                />
              </div>
            </Col>

            <Col lg={2} md={6}>
              <Dropdown>
                <Dropdown.Toggle size="sm" variant="light">
                  Action ({action}) <FaChevronDown />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="dropdown-style"
                  renderOnMount
                  popperConfig={{
                    strategy: "fixed",
                    modifiers: [
                      {
                        name: "preventOverflow",
                        options: { boundary: "viewport" }
                      },
                      {
                        name: "flip",
                        options: { fallbackPlacements: ["bottom-start", "top-start"] }
                      }
                    ]
                  }}>
                  <Dropdown.Header className="fw-bold text-decoration-underline">
                    Filter by
                  </Dropdown.Header>

                  {filterList
                    .filter((item) => !item.isActionFilter)
                    .map((item) => (
                      <Dropdown.Item
                        size="sm"
                        key={item.notificationFilterId}
                        onClick={() => {
                          setAction(item.filterName);
                          onFilter(
                            notificationType,
                            item.notificationFilterId,
                            item.isActionFilter
                          );
                        }}>
                        {item.filterName}
                      </Dropdown.Item>
                    ))}

                  <Dropdown.Divider />

                  <Dropdown.Header className="fw-bold text-decoration-underline">
                    Action
                  </Dropdown.Header>

                  {filterList
                    .filter((item) => item.isActionFilter)
                    .map((item) => (
                      <Dropdown.Item
                        key={item.id}
                        onClick={() => {
                          filterConfirmation(
                            notificationType,
                            item.notificationFilterId,
                            item.isActionFilter,
                            item.filterName
                          );
                        }}>
                        {item.filterName}
                      </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>

            <Col lg={4} className="text-lg-end text-end mt-lg-0 mt-2">
              <Button
                size="sm"
                variant="outline-light"
                className="me-2"
                onClick={() => {
                  setSearch("");
                  setAction("All");
                  onRefresh(notificationType);
                }}
                title="Reset">
                <FaSyncAlt />
              </Button>

              <Button
                size="sm"
                variant="outline-light"
                className="me-2"
                onClick={() => handelViewAll()}>
                <FaEye className="me-1" />
                View All
              </Button>

              <Button
                size="sm"
                variant="outline-light"
                onClick={() => setShowNotifications(!showNotifications)}>
                {showNotifications ? <FaChevronUp /> : <FaChevronDown />}
              </Button>
            </Col>
          </Row>
        </Card.Header>

        <Collapse in={showNotifications}>
          <div>
            <Card.Body className="p-0">
              <Each
                of={notificationData}
                render={(item) => {
                  return (
                    <div key={item.notificationId} className="notification-row row p-2">
                      <div className="row align-items-center">
                        <div className="col-12 col-lg-9">
                          <div className="notification-text">
                            <div className="notification-name">
                              {<span dangerouslySetInnerHTML={{ __html: item.notificationText }} />}
                              <div className="mt-1">
                                <small className="text-muted">
                                  {moment(item.notificationDate).format("DD/MM/YYYY hh:mm A")}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-3 d-flex flex-column justify-content-between align-items-end p-0">
                          <div className="d-flex justify-content-between justify-content-lg-end align-items-center flex-wrap gap-2">
                            <div className="d-flex gap-2">
                              <span
                                className={`action-icon check-icon ${!item.isComplete ? "show-on-hover" : ""}`}
                                onClick={() =>
                                  !readOnly &&
                                  handleNotificationAction(
                                    item.notificationId,
                                    item.isComplete
                                      ? NotificationAction.Incomplete
                                      : NotificationAction.Complete,
                                    item.groupId
                                  )
                                }>
                                <FaCheck />
                              </span>
                              <span
                                className={`action-icon flag-icon ${!item.isNotificationFlag ? "show-on-hover" : ""}`}
                                onClick={() =>
                                  handleNotificationAction(
                                    item.notificationId,
                                    item.isNotificationFlag
                                      ? NotificationAction.Unflag
                                      : NotificationAction.Flag
                                  )
                                }>
                                <FaFlag />
                              </span>
                              <span
                                className={`action-icon delete-icon ${!item.notificationRemove ? "show-on-hover" : ""}`}
                                onClick={() =>
                                  showConfirmation(
                                    item.notificationId,
                                    item.notificationRemove
                                      ? NotificationAction.Undelete
                                      : NotificationAction.Delete,
                                    notificationType
                                  )
                                }>
                                <FaTrash />
                              </span>
                              <span
                                className={`action-icon eye-view view-icon ${!item.isRead ? "show-on-hover " : ""}`}
                                onClick={() =>
                                  handleNotificationAction(
                                    item.notificationId,
                                    item.isRead
                                      ? NotificationAction.Unread
                                      : NotificationAction.Read
                                  )
                                }>
                                <FaEye />
                              </span>
                            </div>

                            <div className="d-flex align-items-center gap-2">
                              <span className={`new-tag ${item.isRead ? "invisible" : ""}`}>
                                NEW!
                              </span>

                              <Button
                                size="sm"
                                className="view-btn a"
                                onClick={() => {
                                  handleNotificationAction(
                                    item.notificationId,
                                    NotificationAction.Read
                                  );
                                  navigate(item.notificationURL);
                                }}>
                                View now »
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }}
              />{" "}
              {totalCount === 0 && (
                <div className="text-center py-5 text-muted">No Notifications Found</div>
              )}
              {totalCount > visibleCount && (
                <div className="text-center border-top py-8">
                  <Button
                    variant="outline-primary"
                    className="view-more-btn"
                    onClick={() => onViewMore(notificationType, visibleCount + 1)}>
                    View More
                  </Button>
                </div>
              )}
            </Card.Body>
          </div>
        </Collapse>
      </Card>
    </>
  );
};
export default NotificationPanel;
